export enum FooterAnalyticsEnum {
  CLICK_FOOTER_ITEM = '[PAC WEB] Footer - Clicou no item do footer',
}
